export const LOCALIZED_NOTIFICATION_KINDS = [
  "swampEnter",
  "fireEnter",
  "foodDepletion",
  "tutorialTurns",
  "tutorialStats",
  "tutorialWinGoal",
  "tutorialFoodEconomy",
  "tutorialTileFood",
  "tutorialGrowth",
  "tutorialFamine",
  "tutorialOneMove",
  "tutorialFoodOverlay",
  "tutorialLandRecovery",
  "tutorialSettings",
  "tutorialRandomEvents",
] as const;

export type LocalizedNotificationKind = (typeof LOCALIZED_NOTIFICATION_KINDS)[number];

export interface NotificationMessage {
  title: string;
  body: string;
}

export interface WorldNotification {
  id: string;
  localizedKind?: LocalizedNotificationKind;
  localizedKinds?: LocalizedNotificationKind[];
  messages?: NotificationMessage[];
  messageIndex: number;
  requiresDecision: boolean;
}

/** Once-per-run gates for auto-pushed notifications (not player prefs). */
export const AUTO_NOTIFICATION_GATES = [
  "tutorialTurns",
  "coreLoopTutorials",
  "tutorialOneMove",
  "foodDepletion",
  "tutorialGrowth",
  "tutorialFamine",
  "tutorialLandRecovery",
  "tutorialFoodOverlay",
  "tutorialRandomEvents",
  "tutorialSettings",
  "tutorialTileFood",
] as const;

export type AutoNotificationGate = (typeof AUTO_NOTIFICATION_GATES)[number];

export interface NotificationState {
  items: WorldNotification[];
  selectedIndex: number;
  nextId: number;
  /** Deterministic once-per-run auto-push gates. */
  autoEmitted: readonly AutoNotificationGate[];
}

export function createEmptyNotificationState(): NotificationState {
  return { items: [], selectedIndex: 0, nextId: 1, autoEmitted: [] };
}

export function hasAutoEmitted(
  state: NotificationState,
  gate: AutoNotificationGate,
): boolean {
  return state.autoEmitted.includes(gate);
}

export function markAutoEmitted(
  state: NotificationState,
  gate: AutoNotificationGate,
): NotificationState {
  if (state.autoEmitted.includes(gate)) {
    return state;
  }
  return {
    ...state,
    autoEmitted: [...state.autoEmitted, gate],
  };
}
